<template>
  <div id="app">
    <Navbar v-if="shouldHaveNavBar" />
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import Buefy from "buefy";

Vue.use(Buefy);

import Navbar from "./components/Navbar.vue";

export default {
  name: "app",
  components: {
    Navbar
  },
  data() {
    return {
      pagesWithoutNavBar: ["/login"]
    };
  },
  computed: {
    shouldHaveNavBar() {
      const shouldHaveNavBar = !this.pagesWithoutNavBar.includes(
        this.$route.path
      );
      if (!shouldHaveNavBar) document.body.classList = [];
      return shouldHaveNavBar;
    }
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #5a65fd;
$primary-invert: findColorInvert($primary);

$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
);

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>